import { notLoggedIn, waitingLoginComplete } from '../../../routes/conditional';
import paths from '../../../routes/paths';
import { loginComplete, loginResend } from '../../../redux/modules/login';
import { getLoginEmail } from '../../../redux/modules/root-reducer';

export const page = {
  path: paths.login.code,
  isAllowed: [notLoggedIn, waitingLoginComplete],
};

export const completeLogin = {
  actionPath: '/actions/login/access-complete',
  codeField: 'code',
  action: ({ body, state }) => loginComplete(body.code, getLoginEmail(state)),
};

export const resendCode = {
  actionPath: '/actions/login/access-resend-code',
  action: ({ state }) => loginResend(getLoginEmail(state)),
};
